module.exports = "/_next/static/images/Connected@2x-ab655ee9d28cfea99c808ce217d6ae55.png";